import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";
import prepareAuthHeaders from "@utils/prepareAuthHeaders";

const REFRESH_INTERVAL = 9 * 60 * 1000;
const BASE_API_URL = process.env.REACT_APP_API_URL;

export class AzureAvatarTokenService {
  private interval: ReturnType<typeof setInterval> | null = null;

  constructor(
    private readonly avatar: SpeechSDK.AvatarSynthesizer,
    private readonly sessionId: string,
  ) {}

  public start(): AzureAvatarTokenService {
    this.startTimer();
    return this;
  }

  public stop() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  private startTimer() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.interval = setInterval(async () => {
      try {
        const { accessToken } = await this.getToken(this.sessionId);
        this.avatar.authorizationToken = accessToken;
      } catch (error) {
        this.startTimer();
      }
    }, REFRESH_INTERVAL);
  }

  private async getToken(sessionId: string): Promise<{ accessToken: string }> {
    const headers = await prepareAuthHeaders(new Headers());
    const res = await fetch(
      `${BASE_API_URL}/avatar/token?${new URLSearchParams({ sessionId })}`,
      {
        headers,
      },
    );

    return res.json();
  }
}
